// @flow
import React from 'react';
import { decodeHtmlEntities } from '@finect/front-utils/html';
import { Head } from '@finect/tabular-components/Head';
import { getArticleRel } from '@finect/tabular-components/Articles';
import { getArticleURL, getSchemaORG, getArticleDescription } from '../../../../utils/articles';
import { getFirstImage } from './../../../../utils/html';

type Props = {
  article: Object,
  html: string
};

const DEFAULT_IMAGE_URL = 'https://static.finect.com/img/articles/rss-articles-cover.jpg';

export const ArticleHead = ({ article, html }: Props) => {
  const title = decodeHtmlEntities(article.title);
  const metaDescription = article.metadata.description ? article.metadata.description : getArticleDescription(html);
  const shareImageUrl = article.image ? article.image : getFirstImage(html) ? getFirstImage(html) : DEFAULT_IMAGE_URL;
  const twitterCardType = ['video'].includes(article.type) ? 'player' : 'summary_large_image';
  const canonical = getArticleURL(article);
  const rel = getArticleRel(article);

  const isVideo = ['video'].includes(article.type);
  const videoPrefix = isVideo ? 'Vídeo - ' : '';

  return (
    <Head
      title={videoPrefix + (article.metadata.title ? article.metadata.title : title)}
      description={videoPrefix + metaDescription}
      canonical={canonical}
      robots={rel === 'nofollow' ? 'noindex' : 'index'}
    >
      <script type="application/ld+json">{getSchemaORG(article, metaDescription)}</script>
      <meta property="og:site_name" content="Finect" />
      <meta property="og:title" content={videoPrefix + title} />
      <meta property="og:locale" content="es_ES" />
      <meta property="og:url" content={canonical} />
      <meta property="og:description" content={videoPrefix + metaDescription} />
      <meta property="og:image" content={shareImageUrl} />
      {isVideo ? <meta property="og:type" content="video" /> : <meta property="og:type" content="article" />}
      {isVideo && <meta property="og:video" content={article.url} />}
      <meta name="twitter:card" content={twitterCardType} />
      <meta name="twitter:site" content="@finect" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={shareImageUrl} />
      {isVideo && <meta name="twitter:player" content={article.url} />}
      {isVideo && <meta name="twitter:player:width" content="640" />}
      {isVideo && <meta name="twitter:player:height" content="360" />}
      <meta name="robots" content="max-image-preview:large" />
    </Head>
  );
};
